const apiUrl = process.env.REACT_APP_API_URL;
export const PostRankingIdProblemaId = async (idRanking: string, idProblema: string, origenTipo?: string) => {
    try {
        const url = origenTipo
            ? `${apiUrl}:8061/jutge/rankings/${idRanking}/problema/${idProblema}?origen_tipo=${origenTipo}`
            : `${apiUrl}:8061/jutge/rankings/${idRanking}/problema/${idProblema}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
